import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.613,5.353a.5.5,0,0,1,0-.707L9.639,2.621a1.235,1.235,0,0,0,0-1.743L9.122.36a1.235,1.235,0,0,0-1.743,0L5.354,2.386a.5.5,0,0,1-.708,0L2.621.36a1.235,1.235,0,0,0-1.743,0L.361.878a1.235,1.235,0,0,0,0,1.743L2.387,4.646a.5.5,0,0,1,0,.707L.361,7.379a1.234,1.234,0,0,0,0,1.742l.517.518a1.234,1.234,0,0,0,1.743,0L4.646,7.613a.5.5,0,0,1,.708,0L7.379,9.639a1.235,1.235,0,0,0,1.743,0l.517-.518a1.234,1.234,0,0,0,0-1.742Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }